import AtendimentoNovo from './AtendimentoNovo';

export default AtendimentoNovo;